import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Modal } from "../ui/modal";
import { listarAjudaEmbedsAtivos } from "../../api/ajudaEmbeds";

interface AjudaEmbed {
  id: number;
  titulo: string;
  url_embed: string;
  paginas: string[];
}

// Botão flutuante que abre um tour interativo (embed cadastrado em
// /ajuda-embeds) quando a página atual tem um configurado. Busca a lista
// uma vez só (raramente muda) e filtra pelo pathname a cada troca de rota.
export default function BotaoAjuda() {
  const location = useLocation();
  const [embeds, setEmbeds] = useState<AjudaEmbed[]>([]);
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    listarAjudaEmbedsAtivos()
      .then(setEmbeds)
      .catch(() => setEmbeds([]));
  }, []);

  const embed = embeds.find((e) => e.paginas.includes(location.pathname));
  // Fecha o modal sozinho ao trocar de rota — senão o tour da página
  // anterior fica aberto por cima da página nova.
  useEffect(() => {
    setAberto(false);
  }, [location.pathname]);

  if (!embed) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setAberto(true)}
        title={embed.titulo}
        className="fixed bottom-6 right-6 z-999 flex h-12 w-12 items-center justify-center rounded-full bg-brand-500 text-xl font-semibold text-white shadow-lg transition hover:bg-brand-600"
      >
        ?
      </button>

      <Modal isOpen={aberto} onClose={() => setAberto(false)} className="max-w-5xl m-4 p-4">
        <h4 className="mb-3 text-base font-semibold text-gray-800 dark:text-white/90">{embed.titulo}</h4>
        <div style={{ position: "relative", paddingBottom: "56.25%", height: 0, width: "100%", borderRadius: 12, overflow: "hidden" }}>
          <iframe
            title={embed.titulo}
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: 0 }}
            src={embed.url_embed}
            allowFullScreen
          />
        </div>
      </Modal>
    </>
  );
}
